module.exports = __webpack_public_path__ + "img/giude1.0a7971c6.jpg";